import { render, staticRenderFns } from "./requestHistory.vue?vue&type=template&id=8598bcec&scoped=true"
import script from "./requestHistory.vue?vue&type=script&lang=js"
export * from "./requestHistory.vue?vue&type=script&lang=js"
import style0 from "./requestHistory.vue?vue&type=style&index=0&id=8598bcec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8598bcec",
  null
  
)

export default component.exports